import axiosInstance from "./axiosInstance";

export type EmployeeWork = {
  id: number;
  employee_id: number;
  title: string;
  problem: string;
  solution: string;
  photo_ids: number[];
  sort_order: number;
  created_at?: string;
  updated_at?: string;
};

export async function getEmployeeWorks(employeeId?: number): Promise<EmployeeWork[]> {
  const { data } = await axiosInstance.get<unknown>("/employee-work", {
    params:
      typeof employeeId === "number" && Number.isFinite(employeeId) && employeeId > 0
        ? { employeeId }
        : undefined,
  });

  return Array.isArray(data) ? (data as EmployeeWork[]) : [];
}
